/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { IBiller } from '../types/biller';

export const getBiller = (state: any): IBiller => state.biller.biller;
export const getBillerLoadStatus = (state: any): string => state.biller.status;